import React, { useEffect, useState } from 'react';
import moment from 'moment';

import { SchedulingWidget } from 'featureLib/AppointmentWidget';

import { addDays, showServiceError, trackAnalytics } from 'common/utils/app.utils';
import { getFetchSlotApiConfig } from 'featureLib/AppointmentEdl/utils';
import { DATE_FORMATS, START_END_DATE_DIFF } from 'featureLib/AppointmentEdl/constants';
import { getOvToken } from 'tokenGeneration/lead.util';
import appConfig from 'config/config';
import { bookSlotsAsync, rescheduleSlotsAsync } from 'featureLib/AppointmentWidget/services';
import { GENERIC_ERROR_MESSAGE } from 'common/constants/app.constants';
import { useHistory } from 'react-router-dom';
import './index.scss';

const WidgetComponent = ({
  open,
  setOpen = () => {},
  title = '',
  sitesData,
  setSitesData,
  selectedOption,
  selectedLineItem,
  reschedule,
  onSubmitClick,
  customerNeedByDate,
  dcpFormSchema,
  lineitems
}) => {
  const { appointmentId, media, pincode, city, circle, rsuCode = '', appointmentDate, orderType, orderSubType, installationAddress, siteReadinessDate } = selectedLineItem;
  const [siteReadyByDate, setSiteReadyByDate] = useState(siteReadinessDate ? new Date(siteReadinessDate) : new Date());
  const [error, setError] = useState('');
  const history = useHistory();
  // const DATE_APPOINTMENT = appointmentId && reschedule ? new Date(appointmentDate) : addDays(new Date(), 4);
  // const DATE_AFTER_PLUS_4 = appointmentId && reschedule ? addDays(appointmentDate, 4) : addDays(new Date(), 8);
  const DATE_APPOINTMENT = addDays(new Date(), sitesData?.customerSegment === 'ENTERPRISE' ? 4 : 2);
  const DATE_AFTER_PLUS_4 = addDays(DATE_APPOINTMENT, START_END_DATE_DIFF);

  const MOCK_PARAMS_OV = {
    media,
    appointmentStartDate: moment(DATE_APPOINTMENT).format(DATE_FORMATS.YYYY_MM_DD), //'2023-11-11'
    appointmentEndDate: moment(DATE_AFTER_PLUS_4).format(DATE_FORMATS.YYYY_MM_DD), //'2023-11-11'
    pincode,
    rsuCode: rsuCode || 'ABC',
    city,
    circle,
    segment: sitesData?.customerSegment,
    orderType,
    orderSubType
  };

  const apiProps = getFetchSlotApiConfig(MOCK_PARAMS_OV).OV;

  const handleSubmitClick = () => {
    setOpen(false);
  };

  const handleWidgetSubmit = async (selectedDate, selectedTime) => {
    try {
      setOpen(false);

      const url = reschedule ? `${appConfig.ovapiBaseUrl}/orders/slots/book/reschedule` : `${appConfig.ovapiBaseUrl}/orders/slots/book`;
      // const selectedAppointmentDate = moment(new Date(new Date().getUTCFullYear(), new Date().getUTCMonth(), selectedDate?.title)).format(DATE_FORMATS.YYYY_MM_DD);
      const selectedAppointmentDate = moment(new Date(selectedDate?.value)).format(DATE_FORMATS.YYYY_MM_DD);
      const selectedAppointmentStartTime = `${selectedTime?.title.split(' ')[0]}:00`;
      const selectedAppointmentEndTime = `${selectedTime?.title.split(' ')[3]}:00`;

      let data = {
        media,
        rsuCode: rsuCode || 'ABC',
        pincode,
        city: city ? city : 'Gurgaon',
        circle: circle ? circle : 'NCR',
        appointmentDate: selectedAppointmentDate,
        // lineItemId: connectivityLineItems?.[0]?.lineItemId,
        startTime: selectedAppointmentStartTime,
        endTime: selectedAppointmentEndTime,
        orderType,
        orderSubType,
        segment: sitesData?.customerSegment
      };

      if (reschedule) {
        data = {
          ...data,
          appointmentId
        };
      }

      const res = reschedule ? await rescheduleSlotsAsync(url, data, `Bearer ${getOvToken()}`) : await bookSlotsAsync(url, data, `Bearer ${getOvToken()}`);
      if (res?.status === 200) {
        const sitesDataCpy = { ...sitesData };

        sitesDataCpy?.sites?.map((item) => {
          if (item.lsiId === selectedLineItem.lsiId) {
            item.siteReadinessStatus = true;
            item.appointmentDate = selectedAppointmentDate;
            item.appointmentStartTime = selectedAppointmentStartTime;
            item.appointmentEndTime = selectedAppointmentEndTime;
            item.appointmentId = reschedule ? appointmentId : res?.data?.result?.appointmentId;
            item.dcpFirstName = dcpFormSchema?.dcpFirstName?.value;
            item.dcpLastName = dcpFormSchema?.dcpLastName?.value;
            item.dcpEmail = dcpFormSchema?.dcpEmail?.value;
            item.dcpPhoneNumber = dcpFormSchema?.dcpPhoneNumber?.value;
          }
        });

        setSitesData(sitesDataCpy);
        onSubmitClick(sitesDataCpy);
      }
    } catch (error) {
      const errorMsg = (error && error.response && error.response.data && error.response.data.status && error.response.data.status.message) || GENERIC_ERROR_MESSAGE;

      showServiceError({
        show: true,
        data: errorMsg,
        redirect: false
      });
    }
  };

  const handleSiteReadyByDateSubmit = () => {
    if (siteReadyByDate > customerNeedByDate) {
      setError('Site readiness date cannot be ahead of customer need by date. Choose a date before the selected customer need by date.');
    } else {
      setError('');
      const sitesDataCpy = { ...sitesData };

      sitesDataCpy?.sites?.map((item) => {
        if (item.lsiId === selectedLineItem.lsiId) {
          item.customerNeedByDate = moment(customerNeedByDate).format(DATE_FORMATS.YYYY_MM_DD);
          item.siteReadinessDate = moment(siteReadyByDate).format(DATE_FORMATS.YYYY_MM_DD);
          item.siteReadinessStatus = false;
        }
      });

      setSitesData(sitesDataCpy);
      onSubmitClick(sitesDataCpy);
    }
  };

  useEffect(() => {
    console.log(reschedule);
    console.log(lineitems, selectedLineItem);
    const data = history && history.location && history.location.state && history.location.state.orderData;
    trackAnalytics({
      eVar0: `b2b|edl|Internet|buy|site readiness|edit details|${reschedule ? 'reschedule' : 'schedule'} appointment`,
      prop0: `b2b|edl|${data && data.customerSegment}|${data && data.product}`,
      prop15: data && data.cpmEmail,
      prop17: data && `${data.cpmFirstName} ${data.cpmLastName}`,
      prop14: data && data.cpmPhoneNumber,
      prop35: data && data.accountName,
      prop39: data && data.customerSegment,
      prop40: data && data.product,
      prop37: lineitems && lineitems.orderType,
      prop43: data && data.sites && data.sites.length,
      prop9: lineitems && lineitems.pincode,
      prop36: data && data.accountName,
      prop20: lineitems && lineitems.installationAddress,
      prop10: data && data.orderId,
      prop29: lineitems && lineitems.media,
      prop16: lineitems && lineitems.city,
      prop7: lineitems && `${lineitems.dcpFirstName} ${lineitems.dcpLastName}`,
      prop8: lineitems && lineitems.dcpPhoneNumber,
      prop9: lineitems && lineitems.dcpEmail,
      prop37: lineitems && lineitems.customerNeedByDate,
      prop14: 'yes',
      prop11: `${data && data.cpmFirstName} ${data && data.cpmLastName}`,
      prop12: data && data.cpmPhoneNumber,
      prop13: data && data.cpmEmail
    });
  }, []);

  return (
    <div className={`schedule_widget_container drawer_modal_controller ${open ? 'active' : ''}`}>
      <div className="drawer">
        <div className="drawer_header">
          <div className="drawer_head">
            <div className="title_info">
              <div className="title_heading">{title}</div>
            </div>
            <span
              className="close_icon"
              onClick={() => {
                setOpen(false);
              }}
            ></span>
          </div>
        </div>
        <div className="drawer_body">
          <div className="scroll_content">
            <div className="site_readiness">
              <div className="form_section">
                {/**
                 * LEFT PANEL
                 */}
                <div className="leftpanel-container">
                  <div className="box">
                    <div className="title">Installation Address</div>
                    <div className="value">{installationAddress || '-'}</div>
                  </div>

                  <div className="box">
                    <div className="title">Customer Need by Date</div>
                    <div className="value">{(customerNeedByDate && moment(customerNeedByDate).format(DATE_FORMATS.DD_MMM_YYYY)) || '-'}</div>
                  </div>
                </div>

                {/**
                 * MAIN PANEL
                 */}
                <div className="mainpanel-container">
                  <div className="site-readiness-section">
                    {
                      selectedOption?.id === 'Yes' ? (
                        <div className="widget-section">
                          <SchedulingWidget apiProps={apiProps} onConfirmClick={handleWidgetSubmit} lineitems={lineitems} />
                        </div>
                      ) : null
                      //     <Fragment>
                      //         <div className="customer-need-by-date-section">
                      //   <h4 className="heading">Customer Need by Date</h4>
                      //   <Datepicker
                      //     name="datepicker"
                      //     label="Customer Need by Date"
                      //     required={true}
                      //     errors={[]}
                      //     touched={false}
                      //     value={customerNeedByDate ? new Date(customerNeedByDate): new Date()}
                      //     // onChange={handleCustomerNeedByDateChange}
                      //     onChange={value =>  setCustomerNeedByDate(value)}
                      //     maxDate={new Date(new Date().setYear(new Date().getFullYear() + 5))}
                      //     minDate={new Date()}
                      //     years={getRange(new Date().getFullYear(), new Date().getFullYear() + 5)}
                      //     disabled={false}
                      //   />
                      // </div>
                      //     <div className="customer-need-by-date-section">
                      //       <h4 className="heading">Tentative site readiness date</h4>
                      //       <Datepicker
                      //         name="datepicker"
                      //         label="Tentative site readiness date"
                      //         required={true}
                      //         errors={[]}
                      //         touched={false}
                      //         value={siteReadyByDate}
                      //         onChange={(value) => setSiteReadyByDate(value)}
                      //         maxDate={new Date(new Date().setYear(new Date().getFullYear() + 5))}
                      //         minDate={new Date()}
                      //         years={getRange(new Date().getFullYear(), new Date().getFullYear() + 5)}
                      //         disabled={false}
                      //       />
                      //       <div className='error-msg'>{error}</div>
                      //       <div className="button_group">
                      //         <Button disabled={siteReadyByDate === undefined || customerNeedByDate === undefined} onClick={handleSiteReadyByDateSubmit}>
                      //           Confirm{' '}
                      //         </Button>
                      //       </div>
                      //     </div>
                      //     </Fragment>
                    }
                  </div>
                  {/* <div className='submit_section'>
                  <Button onClick={handleSubmitClick}>Confirm</Button>
                  </div> */}
                  {/* <div className="customer-need-by-date-section">
                    <h4 className="heading">Customer Need by Date</h4>
                    <Datepicker
                      name="datepicker"
                      label="Customer Need by Date"
                      required={true}
                      errors={[]}
                      touched={false}
                      value={readyByDate}
                      onChange={(value) => setReadyByDate(value)}
                      maxDate={new Date(new Date().setYear(new Date().getFullYear() + 5))}
                      minDate={new Date()}
                      years={getRange(new Date().getFullYear(), new Date().getFullYear() + 5)}
                      disabled={false}
                    />
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="drawer_footer">
          <div className="container">
            <div className="button_group">
              <Button
                variant="outlinebtn"
                onClick={() => {
                  setOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button onClick={handleSubmitClick}>Save</Button>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default WidgetComponent;
